import { ProcessMapList, ProcessMapMode } from './ProcessMapList';

export const ProcessMapListView = () => {
  return <ProcessMapList mode={ProcessMapMode.ACTIVE} />;
};

export const ProcessMapArchivedListView = () => {
  return <ProcessMapList mode={ProcessMapMode.ARCHIVED} />;
};

export { CreateProcessMapForm } from './CreateProcessMapForm/index';
